import script from "./DashboardFavourites.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardFavourites.vue?vue&type=script&setup=true&lang=js"

import "./DashboardFavourites.vue?vue&type=style&index=0&id=c5f942be&lang=scss&scoped=true"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c5f942be"]])

export default __exports__